import React from "react";
import "./FooterStyle.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="top">
        <h2>ECL (SINGAPORE) PTE. LTD.</h2>
      </div>

      <div className="bottom">
        <div className="footer-links">
          <h4>Footer Content Description</h4>

          <a href="/">Home</a>
          <a href="/terms">Terms of Use</a>
          <a href="/privacy">Privacy Statement</a>
        </div>

        <div className="contact-info">
          <h4>EVERETT ASIA LINE PTE LTD</h4>

          <p>subsidiary of ECL(SINGAPORE) PTE LTD</p>
          <p>150 Beach Road, #18-01/04, Gateway West,</p>
          <p>Singapore 189720</p>
          <p>Phone: +65 6326 8368</p>
        </div>
      </div>

      <div className="footer-copy">
        <p>© 2026 ONEVEGA Systems (India) Pvt Ltd.</p>
      </div>
    </footer>
  );
}